// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Q9Edzn{background:#ea492e;width:7px;height:7px;border-radius:50%;margin-right:6px;order:0}.NG_ZOR{position:absolute;background:#ea492e;width:10px;height:10px;border-radius:50%;top:5px;left:5px}.uhr0cb{display:block;position:absolute;top:18px;left:20px;height:14px;width:10px}.Km25AP{width:100%;height:100%;border-top-left-radius:2px;border-bottom-left-radius:2px;background:#272727;display:flex;align-items:center;justify-content:center}.z6ozvw{height:14px;width:14px}.LXgGqt{color:#bababa}.Vq9gNt{padding:10px 28px 10px 10px;line-height:1.25}.VPuXwI{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}div[data-vod-player-min-width~="579px"] .uhr0cb,div[data-vod-player-min-width~="579px"] .NG_ZOR{display:none}div[data-vod-player-min-width~="579px"] .z6ozvw{height:25px;width:25px}div[data-vod-player-min-width~="579px"] .Vq9gNt{padding:0 32px 0 13px;line-height:1.5}[data-playable-in-full-screen='true'] .z6ozvw{height:35px;width:35px}[data-playable-in-full-screen='true'] .Vq9gNt{padding:0 20px 0 0}[data-playable-in-full-screen='true'] .VPuXwI{white-space:normal;overflow:hidden;max-height:40px}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cta-circle": `Q9Edzn`,
	"ctaCircle": `Q9Edzn`,
	"thumbnail-circle": `NG_ZOR`,
	"thumbnailCircle": `NG_ZOR`,
	"thumbnail-icon": `uhr0cb`,
	"thumbnailIcon": `uhr0cb`,
	"scheduled-placeholder": `Km25AP`,
	"scheduledPlaceholder": `Km25AP`,
	"scheduled-icon": `z6ozvw`,
	"scheduledIcon": `z6ozvw`,
	"scheduled-time": `LXgGqt`,
	"scheduledTime": `LXgGqt`,
	"scheduled-text": `Vq9gNt`,
	"scheduledText": `Vq9gNt`,
	"scheduled-title": `VPuXwI`,
	"scheduledTitle": `VPuXwI`
};
export default ___CSS_LOADER_EXPORT___;
